import { blue, green, red } from '@mui/material/colors';

type ThemeName = 'BLUE' | 'GREEN' | 'DANGER';

const configTheme: Record<'PROD' | 'DEV' | 'DEFAULT', ThemeName> = {
    PROD: 'BLUE',
    DEV: 'GREEN',
    DEFAULT: 'DANGER',
};

const BLUE = {
    palette: {
        background: {
            default: '#fff',
        },
        secondary: { main: blue['200'] },
    },
};

const GREEN = {
    palette: {
        background: {
            default: '#fff',
        },
        primary: { main: green['800'] },
        secondary: { main: green.A400 },
    },
};

const DANGER = {
    palette: {
        background: {
            default: '#fff',
        },
        primary: { main: red['800'] },
        secondary: { main: red.A400 },
    },
};

const Themes = {
    BLUE,
    GREEN,
    DANGER,
};

export const getSelectedTheme = (environment: 'DEV' | 'PROD') =>
    Themes[configTheme[environment] || configTheme.DEFAULT] || Themes.DANGER;
